// extracted by mini-css-extract-plugin
export default {"layout":"Layout_layout__uIP3T","main":"Layout_main__Kf7dR"};